export default "__VITE_ASSET__C1zjn7zJ__"